import React from 'react';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import MenuPage from '../../pages/MenuPage';
import FlatButton from 'material-ui/FlatButton';

import translate from '../../lib/i18n/translate'
import './OperatorList.css';

const OperatorList = ({operators, openOperator, onCreateOperatorClick, strings, history}) => {

    return (
        <MenuPage title={strings.Operators + " -- " + operators.branchname} onBackClick={()=>{history.goBack()}}>
            <div className="container">
            <div className="ButtonWrapper right">
            <FlatButton type="button" backgroundColor="#fff" label={strings.AddOperator}
                            fullWidth={false}
                            onTouchTap={onCreateOperatorClick} />
            </div>
            <Table selectable={false} onCellClick={(rowNumber) => openOperator(rowNumber)}>
                <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
                    <TableRow>
                        <TableHeaderColumn  style={{width: 40}}>Id</TableHeaderColumn>
                        <TableHeaderColumn style={{textAlign: 'left'}}>{strings.Name}</TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody displayRowCheckbox={false} showRowHover={true}>
                    {
                        operators.operators.map((o, i) => (
                            <TableRow key={i}>
                                <TableRowColumn style={{width: 40}}>{o.userId}</TableRowColumn>
                                <TableRowColumn>{o.firstName} {o.lastName}</TableRowColumn>
                            </TableRow>
                        ))
                    }
                </TableBody>
            </Table>
            </div>
        </MenuPage>

    )
};

export default translate('OperatorList')(OperatorList);


// WEBPACK FOOTER //
// ./src/components/operator/OperatorList.js